let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8dPRU")).then(() => parcelRequire('3cRh4'));